import { render } from "./TimeSlotByDayResources.vue?vue&type=template&id=3c987dc3&scoped=true&ts=true"
import script from "./TimeSlotByDayResources.vue?vue&type=script&lang=ts"
export * from "./TimeSlotByDayResources.vue?vue&type=script&lang=ts"

import "./TimeSlotByDayResources.vue?vue&type=style&index=0&id=3c987dc3&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c987dc3"]])

export default __exports__